export default __webpack_public_path__ + "static/media/20.1f9a056a.jpg";